import { render, staticRenderFns } from "./dashboard-admin.vue?vue&type=template&id=4a8c6ba5&scoped=true"
import script from "./dashboard-admin.vue?vue&type=script&lang=ts"
export * from "./dashboard-admin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c6ba5",
  null
  
)

export default component.exports